import React from 'react';

import {Skeleton, Stack, Paper, Typography, Box} from 'views/components';
import {HistoryOutlined as HistoryOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

import {Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent} from '@mui/lab';

const EventTimelineTileSkeleton = () => {
  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4}}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <HistoryOutlinedIcon sx={{width: 24, height: 24, color: 'grey'}} />
        <Typography variant="h6">
          <Translate expression='schedule.eventDetail.EventTimelineSection.Title' />
        </Typography>
      </Stack>
      <Timeline position="right">
        <TimelineItem sx={{'&::before': {flex: 0, padding: 0}, 'marginLeft': 0}}>
          <TimelineSeparator>
            <TimelineDot sx={{backgroundColor: '#b0b0b0', border: 'none'}}>
              <Skeleton variant="circular" width={24} height={24} sx={{bgcolor: 'transparent'}} />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent sx={{display: 'flex', alignItems: 'flex-start'}}>
            <Paper sx={{flexGrow: 1}} >
              <Paper
                sx={{
                  p: 1,
                  backgroundColor: '#e0e0e0',
                  boxShadow: 'none',
                  height: 40,
                }}
              >
                <Skeleton variant="text" width={180} height={18} py={4} />
              </Paper>
              <Box sx={{p: 2, height: 88, display: 'flex', flexDirection: 'column'}}>
                <Skeleton variant="text" width={100} height={29} sx={{mb: 1}} />
                <Skeleton variant="text" width={140} height={17} />
              </Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </Paper>
  );
};

export default EventTimelineTileSkeleton;
